export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error("Error")
    error.response = response
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js